import { Avatar, Flex, Text, useToast } from "@chakra-ui/react";
import Image from "components/Image";
import { useRoles } from "hooks/useRoles";
import { useOrgIdWithRel } from "hooks/useOrgIdWithRel";
import React from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { getFirstChar } from "utils";
import logo from "assets/images/tyme-logo.png";

const ChooseOrg = () => {
  const location = useLocation();
  const toast = useToast();
  const history = useHistory();

  const { isPSPMakerCheckerRole, isLoading: isLoadingIsPSPMakerCheckerRole } = useRoles();

  const { listOrganizationOptions, setOrgIdWithRel, selectedOrgIdWithRelName } =
    useOrgIdWithRel();

  if (
    isPSPMakerCheckerRole &&
    selectedOrgIdWithRelName.length > 0
  ) {
    return <Redirect to="/" />;
  }

  if (!isLoadingIsPSPMakerCheckerRole && !isPSPMakerCheckerRole) {
    return <Redirect to="/" />;
  }

  const handleChooseOrg = async (orgId: string) => {
    try {
      await setOrgIdWithRel(orgId);
      toast({
        title: "Organization changed successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
    } catch (error) {
      console.log(error);
    } finally {
      if (location.pathname === "/choose-organization") {
        history.push("/");
      }
    }
  };

  return (
    <Flex
      minH="100vh"
      backgroundColor="#fbfbfb"
      pt="10vh"
      justifyContent="center"
    >
      <Flex flexDir="column" gap="40px">
        <Image src={logo} w="180px" alt="101Digital" ml="40px" />
        <Flex
          p="20px 30px 10px 30px"
          flexDir={"column"}
          border="1px solid var(--chakra-colors-gray-200)"
          borderRadius="10px"
          maxW="400px"
          backgroundColor="white"
          maxH="70vh"
          overflowY="auto"
        >
          <Text textStyle={"h1"} whiteSpace="nowrap">
            Choose Organization
          </Text>
          <Flex gap="10px" my="20px" flexDir="column">
            {listOrganizationOptions?.map((item) => (
              <Flex
                key={item.value}
                gap="15px"
                _hover={{ cursor: "pointer", backgroundColor: "gray.100" }}
                _active={{ backgroundColor: "gray.50" }}
                alignItems="center"
                transition={"all 0.2s ease-in-out"}
                borderRadius="5px"
                p="10px"
                userSelect="none"
                pr="20px"
                border="1px solid var(--chakra-colors-gray-200)"
                onClick={() => handleChooseOrg(item.value)}
                data-testid="choose-organization"
              >
                <Avatar
                  size="md"
                  bg="#EBEBEB"
                  name={getFirstChar(item.label)}
                  textColor="black"
                />
                <Text>{item.label}</Text>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ChooseOrg;
